import { getAzureMapAddressConfig } from "../config/azureConfig";

export type GeocodePoints = {
  latitude: number;
  longitude: number;
};

export const useAzureMaps = () => {
  const getGeocodePromise = (
    addressLine: string | undefined,
    countryRegion: string | undefined,
    adminDistrict: string | undefined,
    locality: string | undefined,
    postalCode: string | undefined
  ): Promise<GeocodePoints | undefined> =>
    new Promise(async (resolve, reject) => {
      if (
        addressLine === undefined &&
        countryRegion === undefined &&
        adminDistrict === undefined &&
        locality === undefined &&
        postalCode === undefined
      )
        reject("Specificare almeno un parametro.");

      const azureMapAddressConfig = getAzureMapAddressConfig();

      const apiVersion = "2025-01-01";

      try {
        const baseUrl = "https://atlas.microsoft.com/geocode";

        const params = new URLSearchParams({
          "subscription-key": azureMapAddressConfig.subscriptionKey,
          "api-version": apiVersion,
          addressLine: addressLine!,
          countryRegion: countryRegion!,
          adminDistrict: adminDistrict!,
          locality: locality!,
          postalCode: postalCode!,
        });

        const response = await fetch(`${baseUrl}?${params.toString()}`);
        const data = await response.json();

        if (data.features.length > 0) {
          const coordinates =
            data.features[0].geometry.coordinates;

          resolve({
            latitude: coordinates[1],
            longitude: coordinates[0],
          });
        }

        resolve(undefined);
      } catch (error) {
        reject(error);
      }
    });

  return { getGeocodePromise };
};
